import type { IAnalyticsAdapter } from '../analytics'

import { facebookInit, fbq } from './facebook.public'
import { facebookSDKInit } from './facebookSDK.public'

import type {
  FacebookEvent,
  FacebookEventParameters,
  FacebookEventOptions,
  FacebookInitData,
} from './facebook.types'

export type FacebookEventApiRequestPost = (event: FacebookEvent, data: FacebookEventParameters) => void


export class FacebookAdapter implements IAnalyticsAdapter {
  protected _checkAccess: () => boolean
  protected _isInit: boolean = false
  protected _logging: boolean = false
  protected _useSDK: boolean = false
  protected _appId: string | undefined
  protected _seq: number = 0
  protected _windowId: string | undefined
  protected _name: string | undefined
  protected _version: string | undefined
  protected _deviceId: string | undefined
  protected _apiRequestPost: FacebookEventApiRequestPost

  constructor(
    checkAccess: () => boolean,
    logging: boolean,
    windowId: string,
    deviceId: string,
    appId: string,
    apiRequestPost: FacebookEventApiRequestPost,
    useSDK: boolean = false,
  ) {
    this._checkAccess = checkAccess
    this._logging = logging
    this._windowId = windowId
    this._deviceId = deviceId
    this._appId = appId
    this._apiRequestPost = apiRequestPost
    this._useSDK = useSDK
  }

  async init() {
    if (!this._appId || !this._checkAccess()) return false
    if (this._useSDK) {
      await facebookSDKInit(this._appId)
    } else {
      facebookInit()
      fbq('init', this._appId);
    }
    this._isInit = true
    return Promise.resolve(true)
  }

  public login(): void {}

  public signUp(): void {}

  public userId(): void {}

  public userProps(): void {}

  public event(): void {}

  public flush() {}

  public facebookEvent(
    event: FacebookEvent,
    data: FacebookEventParameters,
    options?: FacebookEventOptions,
  ): void {
    if (!this._isInit) return
    if (this._logging) console.log('Facebook event: %s', event, data, options)

    if (options) {
      // @ts-ignore
      window.FB.fbq('track', event, data, options)
    } else {
      // @ts-ignore
      FB.track(event, data)
    }
    try {
      this._apiRequestPost(event, {
        ...data,
        ...options,
      })
    } catch (err) {
      console.error(err)
    }
  }

  // https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching/
  public eventInit(data: FacebookInitData): void {
    if (!this._isInit) return
    if (this._logging) console.log('Facebook init:', data)
    // @ts-ignore
    FB.fbq('init', this._appId, data)
  }
}
